module.exports = __webpack_public_path__ + "img/ds-1.56f101be.gif";